import React from "react";
import PropTypes from "prop-types";

import CircularProgress from '@material-ui/core/CircularProgress';

import styles from "./button.module.scss"

const Button = (props) => {
  let buttonClassNames = [styles.root]

  if (props.secondary) {
    buttonClassNames = buttonClassNames.concat(styles.rootSecondary)
  } else {
    buttonClassNames = buttonClassNames.concat(styles.rootPrimary)
  }

  if (props.loading) {
    buttonClassNames = buttonClassNames.concat(styles.rootTransparent)
  }

  if (props.rootClassName) {
    buttonClassNames = buttonClassNames.concat(props.rootClassName)
  }

  return (
    <div className={styles.container}>
      <button className={buttonClassNames.join(' ')} disabled={props.disabled} onClick={props.onClick}>
        {props.children}
      </button>
      {props.loading &&
        <div className={styles.spinnerContainer}>
          <CircularProgress
            className={styles.spinner}
            size={24}
            color="inherit"
          />
        </div>
      }
    </div>
  )
}

Button.propTypes = {
  children: PropTypes.node
}

Button.defaultProps = {
  disabled: false,
  loading: false,
}

export default Button
